import { KPI_VALUE_PERCENT } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const followersEvolutionPercentageConfig = {
    name: 'kpi.instagram.followers_evolution_percentage',
    id: 'followers_evolution_percentage',
    icon: {
        name: 'followers',
        style: colors.blue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_PERCENT,
    tooltip: 'kpi.instagram.tooltip_followers_evolution_percentage',
    size: SIZE_33,
    type: 'kpi',
    loader: DefaultLoader,
    element: KPIDefault
};
